import { createComponent } from '@carvana/merch-components';

export const SearchBarWrapper = createComponent('div', {
  className: 'flex items-center border border-grey-2 p-0'
});

export const SearchBarInnerWrapper = createComponent('div', {
  className: 'flex h-full flex-1 items-center overflow-hidden'
});

export const SearchButton = createComponent('button', {
  className:
    'rounded bg-blue-2 p-8 text-white tl-label-m hover:bg-blue-3 disabled:bg-grey-2'
});

export const SuggestionsContainerClasses =
  'absolute left-0 right-0 m-0 max-h-[190px] overflow-y-auto rounded-b-[8px] border border-grey-2 bg-white p-16 s:max-h-[650px]';

export const RecentSearchRemoveButton = createComponent('button', {
  className:
    'ml-4 hidden cursor-pointer  bg-transparent text-[16px] text-grey-2 m:inline-flex'
});

export const SuggestionItem = createComponent('li', {
  className:
    'cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap py-8 text-left text-grey-5 tl-body-m'
});

export const SuggestionTitleWrapper = createComponent('span', {
  className:
    'flex items-center gap-8 pb-[10px] text-grey-3 tl-body-s min-[390px]:tl-body-m'
});
